<template>
	<div class="recall">
		<div class="d-flex align-items-center recall__header">
			<img :src="PhoneImage" alt="Visszahívás" class="recall__img">
			<p class="recall__title">Visszahívást kérek</p>
		</div>
		<input-unit v-model="email" :options="{
			type: 'text',
			slug: 'phone',
			class: 'recall__input',
			placeholder: 'Telefonszám'
		}"/>

		<button-unit
				class="recall__btn"
				@click-on-btn="goToReCallEmail"
				:options="{
					text: 'Hívás indítása',
					bgColor: '#F7F9EE',
					textColor: '#32341d',
				}"
		/>

	</div>
</template>
<script setup lang="ts">

import {defineEmits, ref} from "vue";
import PhoneImage from "@Images/phone.svg";
import InputUnit from "@/WebApp/Components/Units/InputUnit.vue";
import ButtonUnit from "@/WebApp/Components/Units/ButtonUnit.vue";
import {customErrorAlert, customSuccessAlert} from "@WebAppComposable/SweetAlertComposable";
import axios from "axios";

const email: string = ref('');
const emit = defineEmits(['clickOnBtn']);

const goToReCallEmail = (() => {

	if (email.value.length === 0) {
		customErrorAlert('Nem adtál meg telefonszámot!')
	}

	axios.post('/api/recall', {phone: email.value}).then((response: any) => {
		if (response.status === 200 && response.data.success === true) {
			customSuccessAlert('Hamarosan keressük!', 'Hamarosan keresni fogjuk!');
		}
	}).catch((error: any) => {
		customErrorAlert('Valami hiba történt', error.response.data.message);
	});
});

</script>
<style scoped>

</style>
